// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'workout-tracker-80424',
    appId: '1:50977725126:web:6a9e4fcc1884e6f74215c7',
    storageBucket: 'workout-tracker-80424.appspot.com',
    apiKey: 'AIzaSyDiY5ZyHMLv6h3wsO10_YJ6xheyhcdIg3c',
    authDomain: 'workout-tracker-80424.firebaseapp.com',
    messagingSenderId: '50977725126',
    measurementId: 'G-E9EYZQN54T',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
